import styled from 'styled-components';

export const ButtonCleanFilters = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.textSecondary};
  background: ${({ theme }) => theme.colors.tertiary};
  display: flex;
  align-items: center;
  border-radius: 0.5rem;

  span {
    font-size: 0.9rem;
    padding: 0.25rem 0;
    padding-left: 0.5rem;
  }

  span,
  svg {
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  button {
    margin-left: 0.25rem;
    padding: 0.25rem;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background: transparent;
    border: 0;
    transition: 0.2s linear;

    &:hover {
      background: #ffcdd2;
    }
  }

  & + div {
    margin-left: 0.5rem;
  }
`;
